export const isAppScopeContentManager = () =>
    !!location.host.match(/^cm\./) || APP_SCOPE === "ContentManager";

export const isContentMgmtEnabled = () => CONTENT_MGMT_ENABLED !== "false";
